const testimonialsSlider = document.querySelector('.js-testimonials-slider');

if (testimonialsSlider) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          new Swiper('.js-testimonials-slider', {
            slidesPerView: "auto",
            spaceBetween: 15,
            freeMode: true,
            // initialSlide: 1,
            // centeredSlides: true,
            loop: false,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.js-testimonials-next',
              prevEl: '.js-testimonials-prev',
            },
            breakpoints: { 
            749: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
              1360: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
            },
          });

          observer.unobserve(testimonialsSlider); // Stop observing after initialization
        }
      });
    },
    { threshold: 0.1 } // Adjust threshold if needed
  );

  observer.observe(testimonialsSlider);
}